import React from 'react'
import './footer.css'
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

function Footer() {

    const useStyles = makeStyles((theme) => ({
        container: {
          display: 'grid',
          gridTemplateColumns: 'repeat(12, 1fr)',
          gridGap: theme.spacing(3),
        },
        paper: {
          textAlign: 'center',
          boxShadow:'none',
          background:'transparent'
        },
      }));

      const classes = useStyles();

    return (
        <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
           <h2>Made with 💙 by</h2>  
          <a target="_blank" href="https://www.linkedin.com/in/malaysrivastava3014"><h5>Malay Srivastava</h5></a>  
          
          </Paper>
        </Grid>
      </Grid>
    )
}

export default Footer
